import { render, staticRenderFns } from "./DocumentsUploadPreview.vue?vue&type=template&id=820aa0e4&"
import script from "./DocumentsUploadPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentsUploadPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports